// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/UniNeue.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Uni Neue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

body {
  font-family: "Noto Sans", sans-serif;
  font-weight: 500;
}

::-webkit-scrollbar {
  overflow: auto;
  width: 9px;
  height: 9px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px #dddddd;
  border-radius: 1px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-top: 4px solid transparent;
}

::-webkit-scrollbar-thumb {
  background: #dfdfdf;
  border-radius: 10px;
}
.view-box {
  width: 100%;
  overflow: hidden;
  background-color: white;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
}

.box-body {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}

.loader-container {
  width: 100%;
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

.tileHeading {
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  font-size: 32px !important;
  letter-spacing: -0.5px;
  margin-bottom: 20px;
  margin-top: 10px;
  padding-bottom: 20px;
}
.cnt {
  font-weight: 700;
  font-size: 15px;
  opacity: 0.7;
  text-align: center;
}

.tile_sec {
  border-radius: 8px;
  background-color: #ffffff;
  background-color: #ffffff30;
  padding: 24px 16px;
  aspect-ratio: 1;
  color: #004aaf;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
  transition: 0.3s;
}
.tile_sec:hover {
  box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.tile_sec img {
  width: 65px;
  height: 60px;
}
.tile_sec_head {
  font-size: 12px;
}
.cnt_img {
  width: 100px !important;
  height: 80px !important;
}
.gen_sub_title {
  margin-top: 10px;
  margin-bottom: 10px;
  color: "#000000";
  border-bottom: 1px solid #00000030;
}

.form_group {
  width: 25%;
  max-width: 230px;
  min-width: 150px;
}
.form_group label {
  font-size: 14px;
  font-weight: 600;
}

.loading_wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #0606c269;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.main_table_wrapper {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.437);
  overflow: scroll;
}
.fleet_link {
  cursor: pointer !important;
  text-decoration: underline;
}
.fleet_link:hover {
  font-weight: 700 !important;
  color: #1f77b4 !important;
}

.recharts-legend-wrapper {
  width: 200px !important;
  display: flex;
  flex-direction: column;
}
.recharts-legend-wrapper ul {
  text-align: left !important;
}
.recharts-legend-wrapper ul li {
  width: max-content !important;
}

@media (min-width: 768px) {
  .recharts-legend-wrapper {
    width: 280px !important;
  }
}
.renewal_link {
  text-decoration: none !important;
  color: black !important;
  font-size: 1.25rem;
}
.tile:hover {
  color: #004aaf;
  cursor: pointer;
}
.text_red {
  color: red;
}
.cursor_pointer {
  cursor: pointer;
}
a {
  text-decoration: none !important;
  color: #27292f !important;
}
a:hover {
  color: #1f77b4 !important;
}
.fleet_uptime_icon {
  width: 50px;
  height: 50px;
}
.js-plotly-plot .user-select-none {
  margin: auto;
}
.box-body .js-plotly-plot {
  width: 100%;
  text-align: center;
  justify-content: center;
}

.insight_tables_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 100%;
  align-items: stretch;
}
.bar_graph_section {
  width: 50%;
}
.tables_insight {
  display: flex;
  flex-direction: column;
  gap: 6%;
  align-items: center;
  flex-grow: 1;
  width: 50%;
}
.key_insight_table_title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.8px;
  margin: 0;
}

.restricted_button {
  background: black;
  color: white;
  border: 1px solid black;
  padding: 8px 15px;
  font-weight: 500;
  margin: 10px 0;
  border-radius: 5px;
}

@media screen and (max-width: 900px) {
  .insight_tables_wrapper {
    flex-direction: column;
  }
  .tables_insight,
  .bar_graph_section {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EACE,uBAAuB;EACvB,4CAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;;IAEE,WAAW;EACb;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap\");\r\n@font-face {\r\n  font-family: \"Uni Neue\";\r\n  src: url(\"./assets/fonts/UniNeue.ttf\");\r\n}\r\n\r\nbody {\r\n  font-family: \"Noto Sans\", sans-serif;\r\n  font-weight: 500;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  overflow: auto;\r\n  width: 9px;\r\n  height: 9px;\r\n}\r\n::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 10px #dddddd;\r\n  border-radius: 1px;\r\n  border-left: 4px solid transparent;\r\n  border-right: 4px solid transparent;\r\n  border-bottom: 4px solid transparent;\r\n  border-top: 4px solid transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #dfdfdf;\r\n  border-radius: 10px;\r\n}\r\n.view-box {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  background-color: white;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n}\r\n\r\n.box-body {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 0px;\r\n}\r\n\r\n.loader-container {\r\n  width: 100%;\r\n  height: 30vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.tileHeading {\r\n  font-style: normal;\r\n  font-display: swap;\r\n  font-weight: 700;\r\n  font-size: 32px !important;\r\n  letter-spacing: -0.5px;\r\n  margin-bottom: 20px;\r\n  margin-top: 10px;\r\n  padding-bottom: 20px;\r\n}\r\n.cnt {\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  opacity: 0.7;\r\n  text-align: center;\r\n}\r\n\r\n.tile_sec {\r\n  border-radius: 8px;\r\n  background-color: #ffffff;\r\n  background-color: #ffffff30;\r\n  padding: 24px 16px;\r\n  aspect-ratio: 1;\r\n  color: #004aaf;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n  transition: 0.3s;\r\n}\r\n.tile_sec:hover {\r\n  box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.2);\r\n  background-color: #ffffff;\r\n}\r\n.tile_sec img {\r\n  width: 65px;\r\n  height: 60px;\r\n}\r\n.tile_sec_head {\r\n  font-size: 12px;\r\n}\r\n.cnt_img {\r\n  width: 100px !important;\r\n  height: 80px !important;\r\n}\r\n.gen_sub_title {\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  color: \"#000000\";\r\n  border-bottom: 1px solid #00000030;\r\n}\r\n\r\n.form_group {\r\n  width: 25%;\r\n  max-width: 230px;\r\n  min-width: 150px;\r\n}\r\n.form_group label {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.loading_wrapper {\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background: #0606c269;\r\n  backdrop-filter: blur(2px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 100;\r\n}\r\n.main_table_wrapper {\r\n  width: 100%;\r\n  border: 1px solid rgba(0, 0, 0, 0.437);\r\n  overflow: scroll;\r\n}\r\n.fleet_link {\r\n  cursor: pointer !important;\r\n  text-decoration: underline;\r\n}\r\n.fleet_link:hover {\r\n  font-weight: 700 !important;\r\n  color: #1f77b4 !important;\r\n}\r\n\r\n.recharts-legend-wrapper {\r\n  width: 200px !important;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.recharts-legend-wrapper ul {\r\n  text-align: left !important;\r\n}\r\n.recharts-legend-wrapper ul li {\r\n  width: max-content !important;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .recharts-legend-wrapper {\r\n    width: 280px !important;\r\n  }\r\n}\r\n.renewal_link {\r\n  text-decoration: none !important;\r\n  color: black !important;\r\n  font-size: 1.25rem;\r\n}\r\n.tile:hover {\r\n  color: #004aaf;\r\n  cursor: pointer;\r\n}\r\n.text_red {\r\n  color: red;\r\n}\r\n.cursor_pointer {\r\n  cursor: pointer;\r\n}\r\na {\r\n  text-decoration: none !important;\r\n  color: #27292f !important;\r\n}\r\na:hover {\r\n  color: #1f77b4 !important;\r\n}\r\n.fleet_uptime_icon {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n.js-plotly-plot .user-select-none {\r\n  margin: auto;\r\n}\r\n.box-body .js-plotly-plot {\r\n  width: 100%;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n\r\n.insight_tables_wrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 20px;\r\n  height: 100%;\r\n  align-items: stretch;\r\n}\r\n.bar_graph_section {\r\n  width: 50%;\r\n}\r\n.tables_insight {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6%;\r\n  align-items: center;\r\n  flex-grow: 1;\r\n  width: 50%;\r\n}\r\n.key_insight_table_title {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  letter-spacing: 0.8px;\r\n  margin: 0;\r\n}\r\n\r\n.restricted_button {\r\n  background: black;\r\n  color: white;\r\n  border: 1px solid black;\r\n  padding: 8px 15px;\r\n  font-weight: 500;\r\n  margin: 10px 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n  .insight_tables_wrapper {\r\n    flex-direction: column;\r\n  }\r\n  .tables_insight,\r\n  .bar_graph_section {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
